import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../components/Breadcrumb";
import "../styles/HistorialFacturas.css";

export default function HistorialFacturas() {

    const { expediente } = useParams();
    const history = useHistory();

    const [facturas, setFacturas] = useState([]);
    const [paciente, setPaciente] = useState(null);
    const [loading, setLoading] = useState(true);
    const [facturaAbierto, setFacturaAbierto] = useState(null);

    useEffect(() => {

        async function cargarDatos() {

            try {

                const pacienteRes = await axios.get(`/api/pacientes/${expediente}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                });

                setPaciente(pacienteRes.data);

                const facturasRes = await axios.get(
                    `/api/facturacion/paciente/${expediente}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`
                        }
                    }
                );

                setFacturas(facturasRes.data);

            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }

        }

        cargarDatos();

    }, [expediente]);

    const descargarFactura = async (id) => {
        try {
            const res = await axios.get(
                `/api/facturacion/${id}/pdf`,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );

            const blob = new Blob([res.data], { type: "application/pdf" });
            window.open(URL.createObjectURL(blob), "_blank");

        } catch (err) {
            console.error("Error descargando factura", err);
        }
    };

    const cambiarEstado = async (id) => {

        try {

            await axios.put(
                `/api/facturacion/${id}/estado`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );

            setFacturas(prev =>
                prev.map(p =>
                    p.id === id
                        ? {
                            ...p,
                            estado_factura:
                                p.estado_factura === "FACTURADO"
                                    ? "NO ENTREGADO"
                                    : p.estado_factura === "NO ENTREGADO"
                                    ? "ERRONEO"
                                    : "FACTURADO"
                        }
                        : p
                )
            );

        } catch (err) {
            console.error(err);
        }

    };

    if (loading) {
        return <p>Cargando...</p>;
    }

    return (

        <div className="historial-facturas-page">

            <Breadcrumb />

            <h2>
                Historial de facturas de{" "}
                {paciente
                    ? [paciente.nombre, paciente.primer_apellido, paciente.segundo_apellido]
                          .filter(Boolean)
                          .join(" ")
                    : expediente}
            </h2>
            <table className="historial-table">
                <thead>
                    <tr>
                        <th>Nº factura</th>
                        <th>Fecha</th>
                        <th>Estado</th>
                        <th>Total</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    {facturas.map(factura => (
                        <React.Fragment key={factura.id}>
                            <tr
                                className={`fila-factura ${facturaAbierto === factura.id ? "abierta" : ""}`}
                                onClick={() =>
                                    setFacturaAbierto(
                                        facturaAbierto === factura.id
                                            ? null
                                            : factura.id
                                    )
                                }
                            >
                                <td>{factura.n_factura}</td>
                                <td>{factura.fecha}</td>
                                <td>
                                    <button
                                        className={`estado-btn estado-${factura.estado_factura.toLowerCase().replace(/\s+/g, "-")}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            cambiarEstado(factura.id);
                                        }}
                                    >
                                        {factura.estado_factura}
                                    </button>
                                </td>
                                <td>{Number(factura.total).toFixed(2)} €</td>
                                <td>
                                    <button
                                        className="btn-descargar"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            descargarFactura(factura.id);
                                        }}
                                    >
                                        PDF
                                    </button>
                                </td>
                            </tr>
                            {facturaAbierto === factura.id && (
                                <tr className="fila-actuaciones">
                                    <td colSpan="4">
                                        <div className="detalle-actuaciones">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Tratamiento</th>
                                                        <th>Pieza</th>
                                                        <th>Cuadrante</th>
                                                        <th>Arcada</th>
                                                        <th>Cantidad</th>
                                                        <th>Importe</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {factura.actuaciones.map((act, index) => (
                                                        <tr key={index}>
                                                            <td>{act.tratamiento}</td>
                                                            <td>{act.n_pieza}</td>
                                                            <td>{act.cuadrante}</td>
                                                            <td>{act.arcada}</td>
                                                            <td>{act.cantidad}</td>
                                                            <td>{Number(act.importe).toFixed(2)} €</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
            <div className="acciones-inferiores">
                <button
                    className="volver-btn"
                    onClick={() => history.goBack()}
                >
                    Volver
                </button>
            </div>
        </div>
    );
}